'use strict';

function LoanOfferReupReview() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_LoanOfferReupController, _Paths];

  this.openEditors = 0;

  this.init = function () {
    var _this = this;

    this._super();

    // if users is missing employment or housing info
    // it means they skipped these steps during onboarding (NCS)
    // so forward them to full data collection page instead
    if (!this.hasEmploymentInformation() || !this.hasHousingDetails()) {
      this._hist.replaceUrl(this.paths.loans.offer_refresh_additional_info);
      return;
    }

    this._reviewInfoSubmitButton = this.node.querySelector('.js-reupPreapproval__primaryButton');
    this._editInfoButtons = this.node.querySelectorAll('.js-editData__edit-icon');
    this._cancelEditInfoButtons = this.node.querySelectorAll('.js-cancel');

    this._reviewInfoSubmitButton.addEventListener('click', this._goToNextStep.bind(this));

    Array.from(this._editInfoButtons).forEach(function (btn) {
      btn.addEventListener('click', _this.startEditingMode.bind(_this));
    });

    Array.from(this._cancelEditInfoButtons).forEach(function (btn) {
      btn.addEventListener('click', _this.stopEditingMode.bind(_this));
    });
  };

  this.initAllReady = function () {
    this._super();
    this.analytics.pushEvent('virtual-page-view');
    var analyticsData = this.analytics.constructData('Loan Offer Refresh Started');
    var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
    analyticsRequest.send();
  };

  this.initPage = function () {
    this._super();

    this._debugDetails();

    this.node.removeClass('reupPreapproval--loading');
  };

  this.startEditingMode = function () {
    this.openEditors++;
    this._reviewInfoSubmitButton.mogo().setDisabledState();
  };

  this.stopEditingMode = function () {
    this.openEditors--;
    if (this.openEditors === 0) {
      this._reviewInfoSubmitButton.mogo().removeDisabledState();
    }
  };

  this._goToNextStep = function () {
    this._navTray = $('#tray-navigation').mogo();
    var currentIndex = this._navTray.getSelectedIndex();
    this._navTray.setCompleted(currentIndex);
    this._navTray.goToNextStep();
  };

  this.destroy = function () {
    var _this2 = this;

    if (this._reviewInfoSubmitButton) {
      this._reviewInfoSubmitButton.removeEventListener('click', this._goToNextStep);
    }

    if (this._editInfoButtons) {
      Array.from(this._editInfoButtons).forEach(function (btn) {
        btn.removeEventListener('click', _this2.startEditingMode);
      });
    }

    if (this._cancelEditInfoButtons) {
      Array.from(this._cancelEditInfoButtons).forEach(function (btn) {
        btn.removeEventListener('click', _this2.stopEditingMode);
      });
    }

    this._super();
  };
}